<div role="alert">
  <a href ="https://market.android.com/details?id=com.coulombtech">
    <img src="assets/images/cpnos/cp_full_image.png" alt=""> {{'Get The ChargePoint Mobile App' | T}}
  </a>
  <div class="close" (click)="bannerClose.emit()">X</div>
</div>
